export const LegislativeSessions = [
  { value: '25', label: '2025-2026' },
  { value: '23', label: '2023-2024' },
  { value: '21', label: '2021-2022' },
  { value: '19', label: '2019-2020' },
  // { value: '17', label: '2017-2018' },
  // { value: '15', label: '2015-2016' },
  // { value: '13', label: '2013-2014' },
  // { value: '11', label: '2011-2012' },
  // { value: '09', label: '2009-2010' },
  // { value: '07', label: '2007-2008' },
  // { value: '05', label: '2005-2006' },
  // { value: '03', label: '2003-2004' },
  // { value: '01', label: '2001-2002' }
];